// Config Imports
import { siteConfig } from '@/configs/site-config'

// Asset Imports
import Logo from '@/assets/svg/logo'

/**
 * НЭВТРЭХ ДЭЛГЭЦИЙН БРЭНДИЙН ТАЛ.
 *
 * ! ЗАГВАРЫН ТАНИЛЦУУЛГЫГ ХАСАВ. Өмнө нь «Refine, shadcn/ui дээр бүтсэн…»
 * ! гэсэн тайлбар ба гурван боломжийн жагсаалт байсан — тэр нь ХУДАЛДАЖ
 * ! АВСАН ЗАГВАРЫН зар сурталчилгаа бөгөөд нэвтэрч буй ажилтанд ямар ч
 * ! утгагүй. Байгууллагын дотоод систем өөрийгөө зарах шаардлагагүй.
 *
 * ! Оронд нь лого. Хэн рүү нэвтэрч байгаа нь нэг харцаар ойлгогдоно.
 */
const AuthBrandPanel = () => (
  <aside className='bg-muted/40 hidden flex-col items-center justify-center gap-6 rounded-r-2xl border-s p-8 lg:flex'>
    <Logo className='size-28' />

    <div className='text-center'>
      <p className='text-2xl font-semibold tracking-tight'>
        {siteConfig.name} <span className='text-muted-foreground text-lg'>{siteConfig.displayVersion}</span>
      </p>
      <p className='text-muted-foreground mt-2 text-xs'>{siteConfig.copyright}</p>
    </div>
  </aside>
)

export default AuthBrandPanel
